import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import $ from "jquery";

export const MULTI_COLUMN_SELECTOR = "multi-colums-selector";
export const MULTI_COLUMN_SELECTOR_BUTTON = MULTI_COLUMN_SELECTOR + "-button";

const SelectMultiColumns = (props) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const dropdownRef = useRef();

    useEffect(() => {//click outside dropdown -> close list
        const listener = event => {
            // Do nothing if clicking ref's element or descendent elements
            if (!dropdownRef.current || dropdownRef.current.contains(event.target)) {
                return;
            }
            closeDropdown();
        };
        document.addEventListener("mousedown", listener);

        const dropdownlistener = event => {
            let found = $(event.target).find(".dropdown-menu li.active");

            if (found?.length > 0) {
                $(found).parent().scrollTop(0);
                const activeElementOffsetTop = $(found).offset().top;
                let parentOffsetTop = $(found).parent().offset().top;
                $(found).parent().scrollTop(activeElementOffsetTop - parentOffsetTop);
            }
        };

        if (dropdownRef.current)
            $(dropdownRef.current).on("shown.bs.dropdown", dropdownlistener);

        return () => {
            document.removeEventListener("mousedown", listener);
            if (dropdownRef.current)
                $(dropdownRef.current).off("shown.bs.dropdown", dropdownlistener);
        };
    }, []);

    useEffect(() => {
        if (props.selectedItem) {
            setSelectedItem(props.selectedItem);
        } else {
            setSelectedItem(null);
        }

    }, [props.selectedItem]);

    const closeDropdown = () => {
        const toggleButton = document.getElementById(MULTI_COLUMN_SELECTOR_BUTTON);
        if (toggleButton && toggleButton.getAttribute("aria-expanded") === "true") {
            toggleButton.click();
        }
    }

    const handleItemSelectionClick = (item) => {
        setSelectedItem(item);
        closeDropdown();
        if (props.onItemSelection)
            props.onItemSelection(item);
    }

    //render
    let selectListOptions = props.itemList.map((item, i) => {
        let isActive = "";
        if (item === selectedItem)
            isActive = " active";
        if (props.secondColumnDisplayFunction) {
            return (
                <li key={i}
                    onClick={() => handleItemSelectionClick(item)}
                    className={"dropdown-item" + isActive}
                >
                    <div className="col-md-8 pl-0">
                        <span data-toggle="tooltip" title={props.firstColumnDisplayFunction(item)} >
                            {props.firstColumnDisplayFunction(item)}
                        </span>
                    </div>
                    <div className="col-md-4 pl-0 pr-0">
                        <span data-toggle="tooltip" title={props.secondColumnDisplayFunction(item)}>
                            {props.secondColumnDisplayFunction(item)}
                        </span>
                    </div>
                </li>
            );
        } else {
            return (
                <li
                    key={i}
                    onClick={() => handleItemSelectionClick(item)}
                    className={"dropdown-item" + isActive}
                    data-toggle="tooltip"
                    title={props.firstColumnDisplayFunction(item)}
                >
                    {props.firstColumnDisplayFunction(item)}
                </li>
            );
        }
    });

    let buttonLabel = props.defaultValue;
    if (selectedItem)
        buttonLabel = props.firstColumnDisplayFunction(selectedItem);

    return (
        <div ref={dropdownRef} id={MULTI_COLUMN_SELECTOR} className="dropdown multi-column">
            <button
                id={MULTI_COLUMN_SELECTOR_BUTTON}
                className="form-control w-100"
                type="button"
                data-toggle="dropdown"
                aria-expanded="false"
                aria-haspopup="true"
                disabled={props.disabled}
            >
                {buttonLabel}
                <span id="dropdown-arrow" className="dropdown-toggle caret ml-1"></span>
            </button>
            <ul aria-labelledby={MULTI_COLUMN_SELECTOR_BUTTON} className={"dropdown-menu " + props.dropdownClassName}>
                {selectListOptions}
            </ul>
        </div>
    );
}

SelectMultiColumns.defaultProps = {
    itemList: [],
    firstColumnDisplayFunction: () => "not initialized",
    disabled: false,
    defaultValue: "",
    dropdownClassName: ""
}

SelectMultiColumns.propTypes = {
    itemList: PropTypes.array,
    firstColumnDisplayFunction: PropTypes.func,
    secondColumnDisplayFunction: PropTypes.func,
    onItemSelection: PropTypes.func,
    disabled: PropTypes.bool,
    selectedItem: PropTypes.object,
    defaultValue: PropTypes.string,
    dropdownClassName: PropTypes.string
};

export default SelectMultiColumns;